import config from "../config/index";
const globalData = {};
export function setGlobalData(key, val) {
  globalData[key] = val;
}
export function getGlobalData(key) {
  return globalData[key];
}

 
export const getMockUrl = ()=>{
  if(process.env.NODE_ENV!='development'){
    return ''
  }else{  
   // return "https://www.jiyunsir.com"
   // return "http://www.ws-express.com.cn"
    return `http://xjhy.mall-test.buyagent.omszt.com:8081`;
  }
}
export const getPrefixUrl = ()=>{
  if(typeof window!='undefined'){
    return `${window.location.origin}/api/cmsadmin`
  }else{  
    return `http://localhost:3000/api/cmsadmin`;
  }
}
export const  getProxyUrl  =()=>{
  if(process.env.NODE_ENV!='development'){
    return "http://"+config.proxyLinks.collectionSite;
  }
 // return "https://www.jiyunsir.com/api"
// return "http://www.ws-express.com.cn/api"
 return "http://xjhy.m-shop-test.omszt.com:7888/api";
} 
export const getProxyMallAppUrl =()=>{
  if(process.env.NODE_ENV!='development'){
    return "http://"+config.proxyLinks.mallSite;
  }
  return "http://api-test.jyshop.omszt.com:8081";
} 


export const getProxyShopAppUrl =()=>{
  
  if(process.env.NODE_ENV!='development'){
    return config.proxyLinks.shopSite
  }
  return "http://gateway.sztshop-test.omszt.com:7003";

}

export const getFrontServerAppUrl =()=>{
  if(process.env.NODE_ENV=='development'){
    return "http://salerfrontserver.mps.omszt.com:7001"
  }
  return config.proxyLinks.frontServer
}

export const getQiankunSiteUrl = ()=>{
  // return "//xjhy.shopmember-test.omszt.com:7888";
 //  return "//localhost:8089";
  if(process.env.NODE_ENV!='development'){
    if(!process.client){
      return "//"+config.proxyLinks.qiankunSite;
    }else{
      
      return window.location.origin+ "/qiankun_app_wrap/"
    }
    
  }
  return process.client&& window.location.hostname.indexOf('localhost')>=0 ? `//${window.location.hostname}:8089`:"//xjhy.shopmember-test.omszt.com:7888";
}

 

export const mockJwtMap = {
  [getPrefixUrl()]: "",
};

export function checkMallFetchUrl(url) {
  return url.indexOf("mall=1") >= 0;
}

export function checkShopFetchUrl(url) {
  return url.indexOf("isShop=1") >= 0;
}


export function checkCollectionFetchUrl(url) {
    return url.indexOf("collection=1") >= 0;
  }
export function getToken() {
  return process.client&&window.localStorage.getItem(config.appTokenKey);
}

export function removeToken() {
  if (process.client) {
    window.localStorage.removeItem(config.appTokenKey);
    // remove cookie simultaneously
    const name = encodeURIComponent(config.appTokenKey);
    document.cookie = `${name}=; Max-Age=0; path=/`;
  }
}
export function setToken(val) {
  if (process.client) {
    window.localStorage.setItem(config.appTokenKey, val);
    // set cookie simultaneously (default 7 days)
    const name = encodeURIComponent(config.appTokenKey);
    const value = encodeURIComponent(val);
    const days = 7;
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/`;
  }
}
export function getMallAppToken() {
  return process.client&&window.localStorage.getItem(config.mallAppTokenKey);
}

export function getCookieToken(headers) {
  if (process.server && headers && headers.cookie) {
    const cookies = headers.cookie.split(';').reduce((acc, cookie) => {
      const [key, value] = cookie.trim().split('=');
      acc[key] = value;
      return acc;
    }, {});
    return cookies[config.appTokenKey];
  }
  return null;
}

export function setMallAppToken(val) {
  window.localStorage.setItem(config.appTokenKey, val);
}
export function removeMallAppToken(val) {
  window.localStorage.removeItem(config.appTokenKey, val);
}

export function setIsErpBuyMode(isErp) {
  
  if(process.client){
    if(isErp){
      window.sessionStorage.setItem('batchBindMallOrder','1');
      window.sessionStorage.setItem('batchBindMallOrder','1');
    }else{
      window.sessionStorage.removeItem('batchBindMallOrder');
    }
  }
}

export function isErpBuyMode() {
  if(process.client){
    return !!window.sessionStorage.getItem('batchBindMallOrder');
  }else{
    return false;
  }
 
}
 

export function getCurrentServer(headers) {
  return  process.server
  ? ( getMockUrl() || (headers&&headers["x-custom-header1"]) || (headers&&headers.host))
  : ( getMockUrl() || window.location.origin);
}
 
 
export const localeTo1688CountryMap = {
  "ja_JP":'jp',
  // "zh-CN":'zh',
  // "zh-TW":'zh',
  "en":'en',
  "vi_VN":'vi',
  "ja_JP":'ja',
};

 
export const isTarget_Blank = function () {
  if(process.client && isErpBuyMode() ){
      return "_self";
  }
  return "_blank"
};
export default globalData;
